{MnemoREM
****************************************************************************************************
**                                                                                                **
    Copyright:          (c) MFC Worx
    Address:            Wiefelstederstr. 4a, 26160 Bad Zwischenahn, Germany
    Mobile:             +49 151 12 16 41 43
    Mailto:             michael.ellermann@mfc-worx.com
    HTTP:               mfc-worx.com

    UnitName:           PrjClassWebClientDataAccess
    Folder:             C:\IONOS\TeamAGOGIK\trunk\HBMWeb\SRC\
    Created:            Sun 07.05.2023 21:45
    Author:             Michael Ellermann

    ShortDescription:   Web Tools for MFC Framework

    Description:

**                                                                                                **
****************************************************************************************************
MnemoREM}
unit PrjClassWebClientDataAccess;


interface


uses
  System.SysUtils,
  System.StrUtils,
  System.Classes,
  System.Types,
  Vcl.Controls,
  Vcl.StdCtrls,
  JS,
  jsdelphisystem,

  WEBLib.JSON,
  WEBLib.JsonData,
  WEBLib.Forms,

  VCL.TMSFNCTypes,
  VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics,
  VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl,
  VCL.TMSFNCHTMLText,
  VCL.TMSFNCLabelEdit,

  XData.Web.Client,
  XData.Web.Connection,
  XData.Web.Dataset,
  Data.DB,


  Web,
  WEBLib.REST,
  WEBLib.DBCtrls,
  WEBLib.StdCtrls,


  PrjClassHBMDataAccess,
  wxBaseClassWebTools;


type

  THBMDataType = (dtPeriodicData, dtDescisionData, dtCommonData);
  /// <summary> helper class containing all array and record data needed for transfer
  /// </summary>
  TPrjClassWebClientDataAccess = class(TObject)
  strict private
  private
    FEndPoint           : string;
    FFilter             : string;
    FBaseURL            : string;
    FXDataWebConnection : TXDataWebConnection;
    FClient             : TXDataWebClient;
    FDataSet            : TXDataWebDataSet;
    FDataSetIsOpen      : Boolean;
    FDataType           : THBMDataType;
    function GetDataAccess: TPrjClassHBMDataAccess;
  protected
    procedure DataSetAfterOpen(DataSet: TDataSet);
    procedure XDataClientError(Error: TXDataClientError);
    procedure XDataWebConnectionConnect(Sender: TObject);
    procedure XDataWebConnectionError(Error: TXDataWebConnectionError);
    procedure XDataWebConnectionRequest(Args: TXDataWebConnectionRequest);

    function GetToken: string;

  published
    property BaseURL: string read FBaseURL write FBaseURL;
    property DataSetIsOpen: Boolean read FDataSetIsOpen write FDataSetIsOpen default false;
    property DataType: THBMDataType read FDataType;
    property EndPoint: string read FEndPoint;
    property Filter: string read FFilter;
    property DataAccess: TPrjClassHBMDataAccess read GetDataAccess;
  public
    constructor Create(AOwner: TComponent);
    destructor Destroy; override;
  end;


implementation

uses
  HBMWebData;


constructor TPrjClassWebClientDataAccess.Create(AOwner: TComponent);
begin
  inherited Create;

  FDataSet              := TXDataWebDataSet.Create(AOwner);
  FDataSet.QueryTop     := 0;
  FDataSet.QuerySkip    := 0;
  FDataSet.QueryString  := EmptyStr;
  FDataSet.AfterOpen    := DataSetAfterOpen;

  FXDataWebConnection           := TXDataWebConnection.Create(AOwner);
  FXDataWebConnection.OnError   := XDataWebConnectionError;
  FXDataWebConnection.OnConnect := XDataWebConnectionConnect;
  FXDataWebConnection.OnRequest := XDataWebConnectionRequest;
  FXDataWebConnection.URL       := BaseURL;

  FClient            := TXDataWebClient.Create(nil);
  FClient.Connection := FXDataWebConnection;
  FClient.OnError    := XDataClientError;
end;

destructor TPrjClassWebClientDataAccess.Destroy;
begin
  if Assigned(FDataSet) then
  begin
    FDataSet.Close;
    FreeAndNil(FDataSet);
  end;

  inherited Destroy;
end;

procedure TPrjClassWebClientDataAccess.DataSetAfterOpen(DataSet: TDataSet);
begin
  FDataSetIsOpen := true;
end;

function TPrjClassWebClientDataAccess.GetDataAccess: TPrjClassHBMDataAccess;
begin
  try
    Result := DataModule.DataAccess;
  except
    wxBaseWriteLog.Write('Exception occured in TPrjFormsDefault.GetDataAccess ',slDebug);
  end;
end;

procedure TPrjClassWebClientDataAccess.XDataClientError(Error: TXDataClientError);
begin
  wxBaseWriteLog.Write('XDataClient : An Error occurred while trying to connect. [' + Error.ErrorMessage + ']', slDebug);
end;

procedure TPrjClassWebClientDataAccess.XDataWebConnectionConnect(Sender: TObject);
begin
  wxBaseWriteLog.Write('Connected to XData Server ...', slDebug);
end;

procedure TPrjClassWebClientDataAccess.XDataWebConnectionError(Error:
    TXDataWebConnectionError);
begin
  if Error.Response.StatusCode = 401 then
  begin
    window.localStorage.RemoveItem(DataModule.TokenInformation.TokenStorageName);
  end else
  begin
    wxBaseWriteLog.Write('XDataConnection : An Error occurred while trying to connect. [' + Error.ErrorMessage + ']', slDebug);
  end;
end;

procedure TPrjClassWebClientDataAccess.XDataWebConnectionRequest(Args: TXDataWebConnectionRequest);
begin
  if GetToken <> '' then
  begin
    Args.Request.Headers.SetValue('Authorization', 'Bearer ' + GetToken);
  end;
end;

function TPrjClassWebClientDataAccess.GetToken: string;
begin
  if not JS.IsNull(window.localStorage.getItem(DataModule.TokenInformation.TokenStorageName)) then
    Result := window.localStorage.getItem(DataModule.TokenInformation.TokenStorageName)
  else
    Result := '';
end;

end.




